"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalkerIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = require("../../SVGIcon/SvgIcon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var WalkerIcon = function WalkerIcon(props) {
  return _react["default"].createElement(_SvgIcon.SvgIcon, props, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M0 0h24v24H0z"
  }), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M18.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.7 3.4L12 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C19.8 12 21.8 13 24 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.56-.89-1.68-1.25-2.65-.84L11 8.3V13h2V9.6l1.8-.7z"
  })));
};

exports.WalkerIcon = WalkerIcon;